import { Icon24TextLarge } from '@figma/fpl-icons';
import { fplIcon } from './fplIcon';
import type { SvgComponent } from '@/types/SvgComponent';

export const TEXT_ICON_PATHS = ['M12 5.25V18.75', 'M5.25 8.25V5.25H18.75V8.25', 'M9 18.75H15'];

const TextIconLocal: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}

      {TEXT_ICON_PATHS.map((d) => (
        <path key={d} d={d} stroke="currentColor" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
      ))}
    </svg>
  );
};

export const TextIcon = fplIcon(TextIconLocal, Icon24TextLarge);
